import React from 'react';
import styled from 'styled-components';
import FirstNameIcon from '../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../assets/formComponents/emailIcon.svg';
import CompanyIcon from '../../assets/formComponents/companyIcon.svg';
import { CountrySelect } from '@atlaskit/select';
import { BlueButton } from '../../components/StyledComponents';
import { Link, navigate } from 'gatsby';
import axios from 'axios';
import { validatePhone } from '../../globalFunctions';
import { Title } from '../../components/Esper/HomePage/HomepageSectionOne';
import { StyledInputs as StyledInput } from '../../components/HomePage/EsperSignUpFormComponent';
import { StyledTextArea } from '../../components/Esper/Referral/RequestDemoForm';
import apiHost from '../../apiHost';

const StyledInputs = styled(StyledInput)`
  margin-right: 15px;
  min-width: 350px;
  width: 90%;
  @media (max-width: 439px) {
    min-width: 320px;
  }
  @media (max-width: 415px) {
    min-width: 300px;
  }
  @media (max-width: 376px) {
    min-width: 270px;
  }
  @media (max-width: 321px) {
    min-width: 230px;
  }
`;

const StyledInputsPhone = styled(StyledInput)`
  margin-right: 4px;
  min-width: 230px;
  width: 85%;
  @media (max-width: 439px) {
    min-width: 193px;
  }
  @media (max-width: 415px) {
    min-width: 172px;
  }
  @media (max-width: 376px) {
    min-width: 142px;
  }
  @media (max-width: 321px) {
    min-width: 102px;
  }
`;

export const BlueButtonNew = styled(BlueButton)`
  background-color: #664eab;
  /* min-width: 15rem; */
  margin: 0rem !important;
  font-size: 22px;
  height: 50px;
  background-size: 200% 200%;
  /* justify-self: center; */

  @media (max-width: 768px) {
    font-size: 16px !important;
  }
`;

const IAgreeText = styled.div`
  color: #424769;
  font-size: 16px;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-left: 0em;
  margin-top: 10px;
  margin-bottom: 1rem;
`;

const PasswordMatchError = styled.div`
  font-size: 12px;
  color: #c62828;
  margin-top: 6px;
  height: 21px;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    font-size: 10px;
  }
`;

const PhoneInput = styled.div`
  grid-column: span 1;
  margin-top: -6px;
  width: 100%;
  /* margin-left: 15px; */
  @media (max-width: 768px) {
    margin-left: 15px;
    width: unset;
  }
`;

const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0rem;
  margin-top: 2rem;
  width: fit-content;
  justify-self: center;
  max-width: 100%;
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 580px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const SecondSection = styled.div`
  max-width: 100%;
  display: grid;
  padding-bottom: 5rem !important;
`;
const SectionOneTitle = styled(Title)`
  line-height: 1.15;
  color: #664eab;
  text-align: center;
  padding: 3rem 0rem;
  padding-top: 2rem;
  padding-bottom: 0rem;
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding: 0 3rem;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;

const TextFieldHolder = styled.div`
  display: grid;
  grid-column: span 1;
  @media (max-width: 1000px) {
    grid-column: span 2;
  }
`;
interface IState {
  defaultCountry: any;
  fullName: string;
  fullNameError: boolean;
  email: string;
  emailError: boolean;
  emailErrorText: string;
  company: string;
  isDeveloper: boolean;
  companyError: boolean;
  signupEmailError: boolean;
  contactErrorMessage: string;
  contactNumber: string;
  contactError: boolean;
  sending: boolean;
  errorText: string;
  industry: string;
  quantity: any;
  requirement: string;
  industryError: boolean;
  quantityError: boolean;
  requirementError: boolean;
  contactFocus: boolean;
}

export default class HardwareForm extends React.PureComponent<any, IState> {
  state = {
    defaultCountry: {
      icon: '🇺🇲',
      name: 'United States',
      abbr: 'US',
      code: '1',
      suggested: true,
    },
    fullName: '',
    fullNameError: false,
    lastName: '',
    lastNameError: false,
    email: '',
    contactErrorMessage: '',
    password: '',
    contactNumber: '',
    contactError: false,
    companyError: false,
    confirmPassword: '',
    isDevSelected: undefined,
    company: '',
    isDeveloper:
      this.props.isDeveloper === undefined ? true : this.props.isDeveloper,
    emailError: false,
    signupEmailError: false,
    emailErrorText: '',
    passwordLengthError: false,
    sending: false,
    errorText: '',
    industry: '',
    quantity: '',
    requirement: '',
    industryError: false,
    quantityError: false,
    requirementError: false,
    contactFocus: false,
  };
  sendData = () => {
    this.validateAll();
    if (this.isAllValid()) {
      const hubspotToken = this.getCookieValue('hubspotutk');
      axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/4a813d2c-f5d2-4bc6-ab21-f46cb35014c0',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'message',
              value: this.state.requirement,
            },
            {
              name: 'full_contact_full_name',
              value: this.state.fullName,
            },
            {
              name: 'phone',
              value: this.state.contactNumber,
            },
            {
              name: 'company',
              value: this.state.company,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.setState({
            companyError: false,
            contactError: false,
            fullNameError: false,
            emailError: false,
            industryError: false,
            quantityError: false,
            requirementError: false,
            email: '',
            fullName: '',
            company: '',
            contactNumber: '',
            industry: '',
            quantity: '',
            requirement: '',
          });
          this.navigateThankyou();
        })
        .catch((error: any) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.quantity')) {
                this.setState({ quantityError: true });
              } else if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.mobilephone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Hardware Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };
  handlefullNameChange = (event: any) =>
    this.setState({ fullName: event.target.value });

  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });

  handleContactChange = (event: any) =>
    this.setState({ contactNumber: event.target.value });

  handleCompanyChange = (event: any) =>
    this.setState({ company: event.target.value });

  handleRequirement = (event: any) =>
    this.setState({ requirement: event.target.value });

  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event });
  };

  handleFocusContact = () => this.setState({ contactFocus: true });

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  validateEmail = () => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === false || this.state.email.length > 150) {
      this.setState({
        emailError: true,
      });
    } else {
      axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Hardware Form`,
          failure: false,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      this.setState({ emailError: false });
    }
  };

  validateFullName = () => {
    if (this.state.fullName.length === 0 || this.state.fullName.length > 30) {
      this.setState({
        fullNameError: true,
      });
    } else {
      this.setState({
        fullNameError: false,
      });
    }
  };

  validateCompany = () => {
    if (this.state.company.length === 0 || this.state.company.length > 30) {
      this.setState({
        companyError: true,
      });
    } else {
      this.setState({
        companyError: false,
      });
    }
  };

  validateRequirement = () => {
    if (this.state.requirement.length === 0) {
      this.setState({
        requirementError: true,
      });
    } else {
      this.setState({
        requirementError: false,
      });
    }
  };

  validateContactNumber = () => {
    if (!validatePhone(this.state.contactNumber)) {
      this.setState({
        contactError: true,
        contactErrorMessage: 'Please enter a valid contact number',
      });
    } else {
      this.setState({
        contactError: false,
        contactErrorMessage: '',
      });
    }
  };

  isAllValid = () =>
    !(
      this.state.companyError ||
      this.state.contactError ||
      this.state.fullNameError ||
      this.state.emailError ||
      this.state.requirementError
    );

  validateAll = () => {
    this.validateCompany();
    this.validateContactNumber();
    this.validateRequirement();
    this.validateEmail();
    this.validateFullName();
  };
  navigateThankyou = () => {
    if (this.props.endState) {
      navigate(this.props.endState);
    } else {
      navigate('/submitted');
    }
  };
  render() {
    return (
      <SecondSection id={this.props.formId}>
        <SectionOneTitle>Tell Us Your Requirements</SectionOneTitle>
        <FieldsContainer>
          <TextFieldHolder>
            <StyledInputs
              id="email"
              value={this.state.email}
              aria-label="Email"
              backgroundImage={EmailIcon}
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.signupEmailError}
              type="email"
              placeholder={this.state.isDeveloper ? 'Email' : 'Work Email'}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false &&
              this.state.signupEmailError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.state.emailErrorText}
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid email address'
                      : 'Please enter an email address'}
                  </>
                )
              )}
            </PasswordMatchError>
          </TextFieldHolder>
          <TextFieldHolder>
            <StyledInputs
              id="full-name"
              aria-label="Full name"
              error={this.state.fullNameError}
              backgroundImage={FirstNameIcon}
              onBlur={this.validateFullName}
              value={this.state.fullName}
              maxLength={29}
              onChange={this.handlefullNameChange}
              placeholder={'Full Name'}
              type="text"
              name="Full name"
            />

            <PasswordMatchError id="name-error">
              {this.state.fullNameError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.state.fullName.length > 30
                    ? 'Name should be below 30 characters'
                    : 'Please enter the name'}
                </>
              )}
            </PasswordMatchError>
          </TextFieldHolder>

          <TextFieldHolder>
            <StyledInputs
              id="company-name"
              aria-label="Company Name"
              error={this.state.companyError}
              backgroundImage={CompanyIcon}
              onBlur={this.validateCompany}
              value={this.state.company}
              maxLength={29}
              onChange={this.handleCompanyChange}
              placeholder={`Company Name`}
              type="text"
              name="Company Name"
            />

            <PasswordMatchError id="company-error">
              {this.state.companyError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.state.company.length > 30
                    ? 'Company name should be below 30 characters'
                    : 'Please enter the company name'}
                </>
              )}
            </PasswordMatchError>
          </TextFieldHolder>

          <TextFieldHolder
            style={{ marginTop: '12px' }}
            onMouseDown={this.handleFocusContact}
          >
            <CountrySelect
              value={this.state.defaultCountry}
              onChange={this.handleCountrySelect}
              placeholder="Country"
            />
            <PhoneInput>
              <StyledInputsPhone
                id="Contact-number"
                value={this.state.contactNumber}
                aria-label="Contact"
                style={
                  this.state.contactError
                    ? {
                        boxShadow: '0 0 0 0.1rem #fd7e7ec7',
                        borderRadius: '4px',
                        marginTop: '6px',
                        marginLeft: '8px',
                      }
                    : {
                        boxShadow: 'unset',
                        marginTop: '6px',
                        marginLeft: '8px',
                      }
                }
                maxLength={149}
                onChange={this.handleContactChange}
                onBlur={this.validateContactNumber}
                onFocus={this.handleFocusContact}
                error={this.state.contactError}
                type="text"
                name="contact"
                placeholder={`Contact Number`}
              />
            </PhoneInput>
            <PasswordMatchError
              style={{ gridColumn: 'span 2' }}
              id="contact-error"
            >
              {this.state.contactError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.state.contactErrorMessage
                    ? this.state.contactErrorMessage
                    : 'Please enter the contact number'}
                </>
              )}
            </PasswordMatchError>
          </TextFieldHolder>
          <div
            style={{
              display: 'grid',
              gridColumn: 'span 2',
            }}
          >
            <StyledTextArea
              id="require"
              aria-label="requirement"
              error={this.state.requirementError}
              onBlur={this.validateRequirement}
              value={this.state.requirement}
              //   maxLength={15}
              onChange={this.handleRequirement}
              placeholder={`Hardware Requirement`}
              name="Reqiurement"
            />
            <PasswordMatchError id="requirements-error">
              {this.state.requirementError === true && (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.messages?.AllFormValidationMessagesReq ??
                    'Please enter your requirements'}
                </>
              )}
            </PasswordMatchError>
          </div>
        </FieldsContainer>
        <div
          style={{
            marginBottom: '6px',
          }}
        >
          <IAgreeText>
            By clicking on the Get Started button I agree to Esper's{' '}
            <Link rel="preconnect" to="/terms-of-service/">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link rel="preconnect" to="/privacy-policy/">
              Privacy Policy{' '}
            </Link>
            .
          </IAgreeText>
        </div>
        <BlueButtonWrapper>
          <BlueButtonNew
            style={{ textTransform: 'unset' }}
            id={`${this.props.formId}__get_devices`}
            onClick={this.sendData}
          >
            Get Started
          </BlueButtonNew>
        </BlueButtonWrapper>
      </SecondSection>
    );
  }
}
